import clsx from "clsx";
import React from "react";
import "./detailPageFooterDivider.scss";

interface IDetailPageFooterDividerProps extends React.ComponentPropsWithoutRef<"div"> { }

export const DetailPageFooterDivider = (props: IDetailPageFooterDividerProps) => {
    return <div {...props} className={clsx("detail-page-footer-divider", props.className)} />;
};
